import { colors } from '../constants';
import { formatStatusLabel, getStatusColor } from './statusUtils';
import { normalizeLifecycleStatus } from './queryListUtils';
import { LIFECYCLE_STATUS_STYLES } from '../constants/escalatedQueriesPage';

/**
 * Get lifecycle status metadata (label and color)
 * @param {string} statusLabel - Status label
 * @returns {Object|null} Status metadata or null
 */
const getLifecycleStatusMeta = (statusLabel) => {
  if (!statusLabel) return null;
  const key = normalizeLifecycleStatus(statusLabel);
  return LIFECYCLE_STATUS_STYLES[key] || null;
};

/**
 * Get display status for a query (prioritizes ESCALATED status)
 * @param {Object} query - Query object
 * @returns {Object|null} Status info with label and color
 */
export const getDisplayStatus = (query) => {
  if (!query) return null;
  
  // If query is escalated, always show "ESCALATED" status
  if (query.isEscalated || query.status === 'escalated' || 
      normalizeLifecycleStatus(query.statusLabel || query.status) === 'escalated') {
    return {
      label: 'ESCALATED',
      color: '#d97706', // Orange color for escalated
    };
  }
  
  // Otherwise, show the current status
  const rawStatus = query.statusLabel || query.status;
  if (!rawStatus) return null;
  const lifecycleMeta = getLifecycleStatusMeta(rawStatus);
  if (lifecycleMeta) {
    return {
      label: lifecycleMeta.label,
      color: lifecycleMeta.color,
    };
  }
  const formattedLabel = formatStatusLabel(rawStatus, { uppercase: true });
  const color = getStatusColor(rawStatus) || colors.textSecondary;
  return {
    label: formattedLabel,
    color,
  };
};

/**
 * Format query type for display
 * @param {string} queryType - Query type value
 * @returns {string} Formatted query type
 */
export const formatQueryType = (queryType) => {
  if (!queryType) return 'N/A';
  return queryType
    .toString()
    .replace(/_/g, ' ')
    .toLowerCase()
    .replace(/\b\w/g, (char) => char.toUpperCase());
};
